import { Component, OnInit } from '@angular/core';
import { SessionsService } from '../common/services/sessions.service';
import { Router } from '@angular/router';
import {HttpserviceService} from '../common/services/httpservice.service';
import {retry} from 'rxjs/operators';
import {ConstantsService} from '../common/services/constants.service';
import * as $ from 'jquery';
declare var show_okshan_alert: Function;
declare var reset_slider4: Function;
declare var reset_slider3: Function;

@Component({
  selector: 'app-visitorview',
  templateUrl: './visitor.component.html',
  styleUrls: ['./visitor.component.css']
})
export class VisitorViewComponent implements OnInit {
  testimonialList=[];
  fileUrl;

  constructor(
    private sessionsService:SessionsService,
    private router:Router,
    private httpserviceService:HttpserviceService,
    private _constant: ConstantsService
    ) { }

  ngOnInit(): void {
    window.scrollTo(0, 0);
    this.fileUrl=this._constant.uploadFileUrl 
    setTimeout(() => {
    reset_slider4('.owl-carousel-icons-vis');
      
    this.proceedAdminTestimonialListRequest();
    }, 500);

    if(this.sessionsService.getSession("login_status")!=null)
    {
       if(this.sessionsService.getSession("login_status"))
       {
         window.location.href="#/home";
       }
    }


  }

  /** proceedAdminTestimonialListRequest function used to get testimonial list */ 
  proceedAdminTestimonialListRequest()
  { 
    let result =this.httpserviceService.adminTestimonialListRequest().
     pipe(retry(0)).
     subscribe((data)=>this.adminTestimonialListResponse(data),
     err => {
      //  this.isRequestInprocess=false; 
        show_okshan_alert("Something went wrong !");
       console.log('Something went wrong ', err);       
    })  
  }  

  /** adminTestimonialListResponse function used to handle response */
  adminTestimonialListResponse(response)
  {    
    console.log('getBrandWithCountResponse '+ response.status);
    if(response.status==="success")  
     { 
      this.testimonialList=response.list; 
      setTimeout(() => {
       reset_slider3('.owl-carousel-assoc-fix'); 
      }, 200);      
     }
     else
     {
     show_okshan_alert(response.reason);     
     } 
  }
}
